<template>
  <!--  <div v-if="hasKassirRights || isOrganizerForShow" class="form-group">-->
  <div class="form-group">
    <label class="mb-md-3 bigger-text">{{ trans('pay_method') }}:</label>

    <div class="row row-narrow row-desktop-narrow">
      <div class="col-lg-4 col-md-4 col-6 mb-2"
           v-for="(p, pind) in availablePayMethods"
           :key="`av-pm-${pind}`">
        <div class="pay-method h-100 pointer" @click="handleInput(p.id)">
          <div class="row h-100 align-items-center g-0">
            <div class="col">
              <div class="pe-2">
                <img :src="`/images/${i.src}`"
                     v-for="(i, iind) in p.icons"
                     :key="`v-${pind}-${iind}`"
                     class="pay-icon"
                     :class="i.cl" alt=""/>
                <div class="pay-method-title" v-if="p.title">{{ p.title }}</div>
              </div>
            </div>
            <div class="col-auto">
              <div class="pay-check" :class="{ active: p.id === value}">
                <img src="/images/tick.svg" alt="ok" v-if="p.id === value"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex"

export default {
  name: "PayMethods",
  props: {
    value: {},
  },
  computed: {
    ...mapGetters([
      'hasKassirRights',
      'isOrganizerForShow',
      'isCashierForShow'
    ]),
    ...mapState([
      'user',
      'event',
      'enabledPayMethods'
    ]),
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    isChrome() {
      const ua = navigator.userAgent;
      const isChromium = window.chrome;
      const isOpera = typeof window.opr !== "undefined";
      const isEdge = ua.indexOf("Edg") !== -1;
      const isBrave = navigator.brave && typeof navigator.brave.isBrave === "function";

      return isChromium && !isOpera && !isEdge && !isBrave && ua.includes("Chrome");
    },
    availablePayMethods() {
      let arr = [
        {
          id: 'kaspi',
          icons: [{src: 'pay_method_kaspi.svg', cl: 'kaspi'}]
        },
        {
          id: 'tarlan',
          title: 'Visa/Mastercard',
          icons: [
            { src: 'pay_method_visa.png', cl: 'visa'},
            { src: 'pay_method_mc.png', cl: 'mc'},
          ]
        },
        {
          id: 'tiptop',
          title: 'Visa/Mastercard',
          icons: [
            { src: 'pay_method_visa.png', cl: 'visa'},
            { src: 'pay_method_mc.png', cl: 'mc'},
          ]
        },
      ]
      // if(this.hasKassirRights) {
      if(this.isCashierForShow) {
        arr = [
          {
            id: 'cash',
            title: this.trans('cashdesk'),
            icons: [{src: 'pay_method_cash.svg?2', cl: 'cash'}] }
        ]
      }
      if(this.user && this.isOrganizerForShow && (this.user.invitations_with_price || this.user.roles.filter(r => Number(r.id) !== 4).length)) {
        arr.push({
          id: 'invitation',
          title: `${this.trans('ticket_with_price')}`,
          icons: [{src: 'pay_method_invitation.svg?2', cl: 'invitation'}]
        })
      }
      if(this.isOrganizerForShow) {
        arr.push({
          id: 'invitation_hide',
          title: `${this.trans('ticket_without_price')}`,
          icons: [{ src: 'pay_method_invitation.svg?2', cl: 'invitation'}]
        })
      }
      if(this.user && [1].includes(this.user.id)) {
        // arr.push({
        //   id: 'tiptop',
        //   title: 'Tiptop',
        //   icons: [{src: 'pay_method_tiptop.png', cl: 'tiptop'}]
        // })
        arr.push({
          id: 'installment',
          title: `${this.trans('installment')}`,
          icons: [{src: 'pay_method_bnpl.svg', cl: 'bnpl'}]
        })
        arr.push({
          id: 'tarlan',
          title: 'Visa/Mastercard',
          icons: [
            { src: 'pay_method_visa.png', cl: 'visa'},
            { src: 'pay_method_mc.png', cl: 'mc'},
          ]
        })
        arr.push({
          id: 'kaspi',
          icons: [{src: 'pay_method_kaspi.svg', cl: 'kaspi'}]
        })
      }
      if(this.isIOS || (this.user && [1].includes(this.user.id))) {
        arr.push({
          id: 'tarlan_apple_pay',
          title: `Apple pay`,
          icons: [{src: 'pay_method_apple_pay.svg', cl: 'apple-pay'}]
        })
      }
      if(this.isChrome) {
        arr.push({
          id: 'tarlan_google_pay',
          title: `Google pay`,
          icons: [{src: 'pay_method_google_pay.svg', cl: 'google-pay'}]
        })
      }
      // if(this.event?.id === 791 && ![1].includes(this.user?.id || 0)) {
      //   arr.push({
      //     id: 'tiptop',
      //     title: 'Tiptop',
      //     icons: [{src: 'pay_method_tiptop.png', cl: 'tiptop'}]
      //   })
      // }
      // arr.push({
      //   id: 'smartcore',
      //   icons: [{ src: 'pay_method_sbp.png', cl: 'sbp'}]
      // })
      // }
      // if(this.user && [1,7101].includes(this.user.id)) {
      //   arr.push({
      //     id: 'test',
      //     title: 'test',
      //     icons: [
      //       { src: 'pay_method_visa.png', cl: 'visa'},
      //       { src: 'pay_method_mc.png', cl: 'mc'},
      //     ]
      //   })
      // }
      return arr.filter(i => this.enabledPayMethods.includes(i.id))
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val)
    }
  },
  mounted() {
    console.log('mounted')
  }
}
</script>

<style scoped lang="scss">
.pay-method {
  background: #FFFFFF;
  border: 1px solid #E5E7EA;
  border-radius: 8px;
  padding: 12px 14px;
  .pay-method-title {
    font-size:  14px;
  }
  &:hover {
    background: #f6f6f6;
  }
}
.pay-check {
  border: 1px solid #7E8389;
  border-radius: 100%;
  display: inline-flex;
  justify-items: center;
  align-items: center;
  width: 22px;
  height: 22px;
  position: relative;
  background: transparent;
  img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    max-width: 34px;
  }
  &.active {
    background: #4BB0FE;
    border: 1px solid #4BB0FE;
  }
}
.pay-icon {
  &.mc {
    width: 45px;
  }
  &.visa {
    width: 51px;
    margin-right: 7px;
  }
  &.kaspi {
    width: 116px;
  }
  &.apple-pay {
    width: 60px;
  }
  &.google-pay {
    width: 60px;
  }
  &.sbp {
    width: 80px;
  }
  &.tiptop {
    width: 23px;
  }
  &.bnpl {
    width: 80px;
  }
}

@media(max-width: 768px) {
  .pay-method {
    padding: 8px 12px;
    .pay-method-title {
      font-size:  12px;
    }
    img {
      max-width: 30px;
      &.kaspi {
        max-width: 90px;
      }
      &.visa {
        max-width: 40px;
      }
      &.mc {
        max-width: 35px;
      }
      &.apple-pay {
        max-width: 45px;
      }
      &.google-pay {
        max-width: 46px;
      }
      &.sbp {
        max-width: 55px;
      }
    }
  }
}
</style>
